import apiClient from "@/services/api";

const getApiOrigin = () => {
  const baseURL = apiClient?.defaults?.baseURL;
  if (baseURL) {
    try {
      return new URL(baseURL, window.location.origin).origin;
    } catch {
      // fall through
    }
  }
  return window.location.origin;
};

export const toAbsoluteUrl = (url) => {
  if (!url) return null;

  const s = String(url).trim();
  if (!s) return null;

  if (
    s.startsWith("http://") ||
    s.startsWith("https://") ||
    s.startsWith("data:") ||
    s.startsWith("blob:")
  ) {
    return s;
  }

  if (s.startsWith("//")) {
    return `${window.location.protocol}${s}`;
  }

  const origin = getApiOrigin();

  if (s.startsWith("/")) {
    return `${origin}${s}`;
  }

  return `${origin}/${s}`;
};

export const resolveEmployerLogoUrl = (jobOrEmployer) => {
  if (!jobOrEmployer) return null;

  const employer = jobOrEmployer?.employer;
  const employerLogo =
    employer && typeof employer === "object" ? employer.logo_url : null;

  return toAbsoluteUrl(
    employerLogo || jobOrEmployer.logo_url || jobOrEmployer.image_url,
  );
};
